<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2021-05-31 03:17:40
    Description : 审核列表
  -->
  <div class="main">
    <gaia-header :isShowUpload="false" />
    <div class="page" style="padding-top: 100px">
      <div style="margin-top: 10px">
        <div class="review-list">
          <el-page-header
            @back="goBack"
            style="margin: 20px 0"
            title="返回"
            :content="`审核列表 (${titleList[selectActive]})`"
          />
          <div class="title">
            <div class="review-select" style="margin-top: -46px">
              <el-input
                v-model="keyword"
                prefix-icon="el-icon-search"
                placeholder="标题"
                size="mini"
                style="width: 140px; margin-right: 10px"
                @keyup.enter.native="getManageList()"
              />
              <el-select
                  v-if="![4].includes(selectActive)"
                  v-model="state"
                size="mini"
                style="width: 150px; margin: 0 20px 0 0"
                @change="getManageList()"
              >
                <el-option label="全部" value=""> </el-option>
<!--                <el-option label="上传中" value="uploading" />-->
<!--                <el-option label="处理中" value="processing" />-->
                <el-option label="待审核" value="waitting" />
                <el-option label="审核通过" value="pass" />
                <el-option label="审核未通过" value="notPass" />
<!--                <el-option label="处理失败" value="processingFailure" />-->
              </el-select>
            <el-select
                v-if="[4].includes(selectActive)"
                v-model="state"
                size="mini"
                style="width: 150px; margin: 0 20px 0 0"
                @change="getManageList()"
            >
                <el-option label="全部" value=""> </el-option>
                <el-option label="待审核" value="waitting" />
                <el-option label="审核通过" value="pass" />
                <el-option label="审核未通过" value="notPass" />
            </el-select>
            </div>
          </div>
          <manage-card
            class="card"
            v-if="[0, 1, 2, 3].includes(selectActive)"
            v-for="(item, i) in manageList"
            :key="item.id"
            :data="item"
            @delClick="delClick(item.id, selectActiveList[selectActive])"
            @editClick="editClick(item.id, selectActiveList[selectActive], item.contentType)"
          />
          <manage-card
            class="card"
            v-if="[4].includes(selectActive)"
            v-for="(item, i) in manageList"
            :key="item.id"
            :data="item"
            @delClick="delClick(item.id, selectActiveList[selectActive])"
            @editClick="editClick(item.id, selectActiveList[selectActive], item.contentType)"
          />
          <manage-card
            class="card"
            v-if="[5].includes(selectActive)"
            v-for="(item, i) in manageList"
            :key="item.id"
            :data="item"
            @delClick="delClick(item.id, selectActiveList[selectActive])"
            @editClick="editClick(item.id, selectActiveList[selectActive])"
          />
          <manage-card
            class="card"
            v-if="[6].includes(selectActive)"
            v-for="(item, i) in manageList"
            :key="item.id"
            :data="item"
            :height="380.8"
            @delClick="delClick(item.id, selectActiveList[selectActive])"
            @editClick="editClick(item.id, selectActiveList[selectActive])"
          />
          <div v-loading="loading" style="padding-top: 10px"></div>
        </div>
      </div>
    </div>
    <el-dialog
      title="教程作品池-作品基本信息设置"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <h3 style="margin-bottom: 10px">标题</h3>
      <el-input v-model="cworkTitle" />
      <h3 style="margin: 10px 0">
        免费时长
        <span style="font-size: 12px; font-weight: 600">
          (仅在付费教程中生效且仅可在上传时进行设置)
        </span>
      </h3>
      <div>{{ cworkDuration }}</div>
      <span slot="footer" class="dialog-footer">
        <div style="text-align: left">
          <el-button
            type="primary"
            @click="updateCwork"
            style="width: 200px"
            size="small"
          >
            保存
          </el-button>
          <el-button @click="dialogVisible = false" size="small">
            取消
          </el-button>
        </div>
      </span>
    </el-dialog>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next, jumper"
        :disabled="loading"
        :page-size="page.pageSize"
        :total="page.total"
        :current-page="page.pageIndex"
        @current-change="getManageList"
      />
    </div>
    <gaia-footer />
  </div>
</template>

<script>
import gaiaHeader from "@/components/gaia-header/gaia-header";
import GaiaFooter from "@/components/gaia-footer/gaia-footer";
import {
  getWorksList,
  getHdrList,
  getShowList,
  getManagePersonalMaterial,
  getSetPersonalCourse,
  personalCworksList,
  getPersonal48Works,
  updateCwork,
  delWorks,
  deleteCourse,
  deleteWorkById,
  deleteCwork,
  deleteMaterial,
} from "@/api/personal";
import Gaia48Card from "@/components/work-card/gaia48-card.vue";
import ManageCard from "@/components/work-card/manage-card.vue";
export default {
  components: {
    gaiaHeader,
    GaiaFooter,
    Gaia48Card,
    ManageCard,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_RESOURCES_URL,
      selectActive: 0,
      titleList: [
        "作品",
        "HDR作品",
        "展映作品",
        "素材",
        "学院教程",
        "学院作品池",
        "Gaia48",
      ],
      selectActiveList: [
        "works",
        "hdr",
        "show",
        "material",
        "academy",
        "cwork",
        "gaia48",
      ],
      page: {
        pageIndex: 1,
        pageSize: 8,
        total: 0,
      },
      loading: false,
      keyword: "",
      manageList: [],
      state: "",
      sort: "time",
      isSelf: true,
      dialogVisible: false,
      cworkTitle: "",
      cworkId: "",
      freeDuration: 0,
      cworkDuration: "",
    };
  },
  created() {
    this.selectActive = Number(this.$route.query.type);
    this.getManageList();
  },
  methods: {
    /**
     * 返回个人中心
     */
    goBack() {
      const id = JSON.parse(localStorage.getItem("user")).account.id;
      this.$router.push(`/center/${id}`);
    },
    getManageList(pageIndex = 1) {
      this.page.pageSize = 8;
      if (this.selectActive === 0) {
        this.getWorksList(pageIndex);
      } else if (this.selectActive === 1) {
        this.getHdrList(pageIndex);
      } else if (this.selectActive === 2) {
        this.getShowList(pageIndex);
      } else if (this.selectActive === 3) {
        this.getManagePersonalMaterial(pageIndex);
      } else if (this.selectActive === 4) {
        this.getSetPersonalCourse(pageIndex);
      } else if (this.selectActive === 5) {
        this.personalCworksList(pageIndex);
      } else if (this.selectActive === 6) {
        this.page.pageSize = 9;
        this.getPersonal48Works(pageIndex);
      }
    },
    getList(pageIndex = 1) {},
    /**
     * 作品列表
     */ getWorksList(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      let data = {
        ...this.page,
        keywords: this.keyword,
        allowDownload: this.allowDownload,
        sort: this.sort,
        state: this.state,
      };
      if (!this.isSelf) {
        data.userId = this.id;
      }
      getWorksList(data)
        .then((res) => {
          this.flushPage(res);
          this.manageList = res.worksList.map((el) => {
            return {
              id: el.id,
              cover: this.getCover(el),
              title: el.title,
              duration:
                el.video && el.video.videoInfo
                  ? el.video.videoInfo.duration
                  : 0,
              size: el.video.formatInfo.size,
              state: el.video.state,
            };
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    /**
     * hdr列表
     */
    getHdrList(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      let data = {
        ...this.page,
        keywords: this.keyword,
        see: this.see,
        sort: this.sort,
        state: this.state,
      };
      if (!this.isSelf) {
        data.userId = this.id;
      }
      getHdrList(data)
        .then((res) => {
          // console.log(res);
          this.flushPage(res);
          this.manageList = res.worksList.map((el) => {
            return {
              id: el.id,
              cover: this.getCover(el),
              title: el.title,
              duration:
                el.video && el.video.videoInfo
                  ? el.video.videoInfo.duration
                  : 0,
              size: el.video.formatInfo.size,
              state: el.video.state,
            };
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    /**
     * 展映列表
     */
    getShowList(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      let data = {
        ...this.page,
        keywords: this.keyword,
        see: this.see,
        sort: this.sort,
        state: this.state,
      };
      if (!this.isSelf) {
        data.userId = this.id;
      }
      getShowList(data)
        .then((res) => {
          // console.log(res);
          this.flushPage(res);
          this.manageList = res.worksList.map((el) => {
            return {
              id: el.id,
              cover: this.getCover(el),
              title: el.title,
              duration: el.video ? el.video.videoInfo.duration : 0,
              size: el.video.formatInfo.size,
              state: el.video.state,
            };
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    /**
     * 素材列表
     */
    getManagePersonalMaterial(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      let data = {
        ...this.page,
        ...{
          keywords: this.keyword,
          userId: this.id,
          MaterialType: this.MemberType,
          state: this.state,
        },
      };
      getManagePersonalMaterial(data)
        .then((res) => {
          // console.log(res);
          this.flushPage(res);
          this.manageList = res.materialApplyList.map((el) => {
            return {
              ...el,
              id: el.material.id,
              cover: this.getCover(el.material),
              title: el.material.title,
              duration:
                el.material.video && el.material.video.videoInfo
                  ? el.material.video.videoInfo.duration
                  : -1,
              size: this.getSize(el.material),
              state: el.state || "processingFailure",
            };
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    /**
     * 学院列表
     */
    getSetPersonalCourse(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex
      let data = {
        ...this.page,
        ...{
          keywords: this.keyword,
          userId: this.id,
          courseType: this.courseType,
          state: this.state,
        },
      };
      getSetPersonalCourse(data)
        .then((res) => {
          // console.log(res);
          this.flushPage(res);
          this.manageList = res.courseApplyList.map((el) => {
            return {
              id: el.course.id,
              contentType: el.course.contentType,
              cover: this.getCover(el.course),
              title: el.course.title,
              duration:
                el.course.video && el.course.video.videoInfo
                  ? el.course.video.videoInfo.duration
                  : -1,
              size: -1,
              state: el.state || "processingFailure",
            };
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    /**
     * 学院作品池
     */
    personalCworksList(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      let data = {
        ...this.page,
        keywords: this.keyword,
        sort: this.sort,
        state: this.state,
      };
      personalCworksList(data)
        .then((res) => {
          // console.log(res);
          this.flushPage(res);
          this.manageList = res.worksList.map((el) => {
            return {
              id: el.id,
              cover: this.getCover(el),
              title: el.title,
              duration:
                el.video && el.video.videoInfo
                  ? el.video.videoInfo.duration
                  : 0,
              freeDuration: el.duration,
              size: el.video.formatInfo.size,
              state: el.video ? el.video.state : "processingFailure",
            };
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    /**
     * 48列表
     */
    getPersonal48Works(pageIndex = 1) {
      this.loading = true;
      this.page.pageIndex = pageIndex;
      const data = {
        ...this.page,
        keywords: this.keyword,
        AreaId: this.areaId,
        KeyWord: this.keyword,
        isSelf: this.isSelf,
        state: this.state,
      };
      if (!this.isSelf) {
        data.userId = this.id;
      }
      getPersonal48Works(data)
        .then((res) => {
          // console.log(res);
          this.flushPage(res);
          this.manageList = res.works.map((el) => {
            return {
              id: el.id,
              cover: this.getCover(el),
              title: el.title,
              duration:
                el.video && el.video.videoInfo
                  ? el.video.videoInfo.duration
                  : 0,
              size: el.video.formatInfo.size,
              state: el.video.state,
            };
          });
          this.loading = false;
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    updateCwork() {
      this.dialogVisible = false;
      const data = {
        CworkName: this.cworkTitle,
        duration: this.freeDuration,
        cworkId: this.cworkId,
      };
      updateCwork(data).then((res) => {
        console.log(res);
        this.$message.success("修改成功");
        this.getManageList(this.page.pageIndex);
      });
    },
    /**
     * 获取文件size
     */
    getSize(material) {
      if (material.video) {
        return material.video.formatInfo.size;
      } else if (material.template) {
        return material.template.size;
      } else if (material.virtualProperty) {
        return material.virtualProperty.size;
      }
      return 0;
    },
    flushPage(res) {
      this.page.pageIndex = res.page.pageIndex;
      this.page.pageSize = res.page.pageSize;
      this.page.total = res.page.total;
      setTimeout(() => {
        this.$forceUpdate();
      }, 0);
    },
    getCover(data) {
      let cover = "";
      if (data.cover) {
        return data.cover;
      }
      if (data.video) {
        data.video.resources.map((el) => {
          if (el.resourceName === "180") {
            cover = el.resourceKey;
          }
        });
        return cover;
      }
    },
    delClick(id, type) {
      console.log("id", id, type, this.selectActive);
      if (["works", "hdr", "show", 'cwork', 'material', 'academy'].includes(type)) {
        this.$confirm(`确认删除该作品吗?`)
          .then((_) => {
            this.loading = true;

            if ([0, 1, 2].includes(this.selectActive)) {
              delWorks(id).then((res) => {
                this.getManageList(this.page.pageIndex);
              });
            } else if ([3].includes(this.selectActive)) {
              deleteMaterial(id).then((res) => {
                this.getManageList(this.page.pageIndex);
              });
            } else if (this.selectActive === 4) {
              deleteCourse(id).then((res) => {
                this.getManageList(this.page.pageIndex);
              });
            } else if (this.selectActive === 5) {
              deleteCwork(id).then((res) => {
                this.getManageList(this.page.pageIndex);
              });
            } else if (this.selectActive === 6) {
              deleteWorkById(id).then((res) => {
                this.getManageList(this.page.pageIndex);
              });
            }
          })
          .catch((_) => {});
      }
      // else if (type === "material") {
      //     open(`/desktop/gaia-material/video-update?id=${id}`);
      // }
    },
    editClick(id, type, contentType = "video") {
      if (["works", "hdr", "show"].includes(type)) {
        open(`/works/private/settings/${id}`);
      } else if (type === "material") {
        console.log(contentType)
        if(contentType === 'template') {
          open(`/desktop/gaia-material/template-update?id=${id}`);
        }
        if(contentType === 'music') {
          open(`/desktop/gaia-material/music-update?id=${id}`);
        }
        if(contentType === 'other') {
          open(`/desktop/gaia-material/other-update?id=${id}`);
        }
        if(contentType === 'picture') {
          open(`/desktop/gaia-material/picture-update?id=${id}`);
        }
        if(contentType === 'video') {
          open(`/desktop/gaia-material/video-update?id=${id}`);
        }
        if(contentType === 'virtualProperty') {
          open(`/desktop/gaia-material/virtual-update?id=${id}`);
        }
      } else if (type === "academy") {
        open(`/college/private/MainUpload?type=${contentType}&way=${id}`);
      } else if (type === "cwork") {
        this.dialogVisible = true;
        // open(`/college/private/MainUpload?type=${contentType}&way=${id}`);
        this.manageList.map((el) => {
          if (el.id === id) {
            this.cworkId = el.id;
            this.cworkTitle = el.title;
            this.cworkDuration = `${(el.freeDuration / 1000).toFixed(2)} 秒`;
          }
        });
      } else if (type === "gaia48") {
        open(`/desktop/gaia-48/update?id=${id}`);
      }
      console.log(id, type);
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  min-width: 1300px;
  background: #ebebeb;
}
.review-list {
  width: 100%;
  min-height: 660px;
  margin: 0 auto 20px;
  padding: 10px 20px;
  background: #ffffff;
  .title {
    font-size: 16px;
    margin: 0 0 40px;
    color: #313333;
    font-weight: bold;
  }
}
.review-select {
  float: right;
}
.el-select-dropdown__item {
  font-size: 12px;
}
.card {
  margin-right: 24px;
}
.card:nth-child(4n + 6) {
  margin-right: 0;
}
.pagination {
  position: relative;
  bottom: 100px;
  text-align: center;
}
</style>
